<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#">
      <h2 style="overflow:hidden">
        <router-link class="text-white" to="/" style="text-decoration:none">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </router-link>
        <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
          <span class="navbar-toggler-icon"><i class="fa fa-bars" aria-hidden="true" style="color:#3f82b6;margin-top: 6px;"></i></span>
        </button>
      </h2>
    </b-link>
    <b-navbar-nav class="d-md-down-none">
      <breadcrumb :list="list"/>
      <!-- <b-nav-item href='#/visitor' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 1 ?'bg-secondary':'')">Visitor</b-nav-item>
      <b-nav-item href='#/book' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 2 ?'bg-secondary':'')">Facility</b-nav-item>
      <b-nav-item href='#/complain' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 3 ?'bg-secondary':'')">User Complaint</b-nav-item>
      <b-nav-item href='#/marketplace' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 4 ?'bg-secondary':'')">Market Place</b-nav-item>
      <b-nav-item href='#/payment' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 5 ?'bg-secondary':'')">Payment</b-nav-item>
      <b-nav-item href='#/forum' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 6 ?'bg-secondary':'')">Forum</b-nav-item>
      <b-nav-item href='#/settings' :class="'px-3 p-2 mb-2 ' + (getChosenModule == 7 ?'bg-secondary':'')">Settings</b-nav-item> -->
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <!-- <b-nav-item class="d-md-down-none">
        <header-notification :after-click-notification="afterClickNotification" ref="headerNotification"/>
      </b-nav-item> -->
      <HeaderDropdown/>
    </b-navbar-nav>
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <!-- <notification-bubble :after-click-notification="afterClickNotification" ref="notificationbubble"/> -->
  </header>
</template>
<script>
  import moment from 'moment'
  import axios from 'axios'
  import HeaderDropdown from './HeaderDropdown.vue'
  import HeaderNotification from './HeaderNotification.vue'
  import NotificationBubble from './NotificationBubble'
  import Breadcrumb from './Breadcrumb.vue'
  const numeral = require('numeral')

  export default {
    name: 'header',
    components: {
      HeaderDropdown,
      HeaderNotification,
      NotificationBubble,
      Breadcrumb
    },
    data () {
      return {
        // allNotificationTotals: 0,
        notificationList: []
      }
    },
    computed: {
      list () {
        return this.$route.matched
      }
    },
    created () {
      /* this.getUnreadNotificationList()
      if (this.$store.state.firebaseMessaging !== null) {
        this.$store.state.firebaseMessaging.onMessage((message) => {
          this.getUnreadNotificationList()
          this.$refs.notificationbubble.createBubble({
            title: message.data.title,
            body: message.data.body,
            type: message.data.type,
            uuid: message.data.uuid,
            notificationUuid: message.data.notificationUuid
          })
        })
      } */
    },
    mounted () {
      document.addEventListener('keydown', (event) => {
        if (event.keyCode === 115) { // F4
          event.preventDefault()
          this.fullScreenMode()
        }
      })
    },
    methods: {
      fullScreenMode () {
        document.body.classList.toggle('header-hidden')
        document.body.classList.toggle('sidebar-hidden')
      },
      headerToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('header-hidden')
      },
      sidebarToggle (e) {
        e.preventDefault()
        // document.body.classList.toggle('sidebar-hidden')
        document.body.classList.toggle('sidebar-minimized')
        document.body.classList.toggle('brand-minimized')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },
      getUnreadNotificationList () {
        axios.get(window.AppConfig.apiUrl + 'notification?admin=1&unread=1&limit=10')
          .then(response => {
            if (response === undefined) return false
            this.notificationList = []
            // this.allNotificationTotals = numeral(response.data.total_items).format('0a')
            for (let i = 0; i < response.data._embedded.notification.length; i++) {
              let uuid = null
              if (response.data._embedded.notification[i].type === 'Facility') {
                uuid = response.data._embedded.notification[i].facilityBooking
              } else if (response.data._embedded.notification[i].type === 'Complain') {
                uuid = response.data._embedded.notification[i].complain
              } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'PanicResolve') {
                uuid = response.data._embedded.notification[i].panicAlert
              } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'Request') {
                uuid = response.data._embedded.notification[i]._embedded.request.uuid
              } else if (response.data._embedded.notification[i].type === 'Task') {
                uuid = response.data._embedded.notification[i]._embedded.task.uuid
              } else {
                uuid = response.data._embedded.notification[i].visitor
              }
              this.notificationList.push({
                notificationUuid: response.data._embedded.notification[i].uuid,
                uuid: uuid,
                userProfile: response.data._embedded.notification[i].userProfile,
                title: response.data._embedded.notification[i].title,
                createdAt: moment(response.data._embedded.notification[i].createdAt).from(moment().format()),
                type: response.data._embedded.notification[i].type
              })
            }
            this.$refs.headerNotification.setNotificationList(this.notificationList)
            this.$refs.headerNotification.setNotificationTotals(numeral(response.data.total_items).format('0a'))
          }).catch(error => {
            this.$store.dispatch('errorMessage', error)
              .then(errMsg => {
                this.$alertify.error(errMsg)
              })
          })
      },
      afterClickNotification (notificationUuid, uuid, type) {
        axios.patch(window.AppConfig.apiUrl + 'notification/' + notificationUuid, {unread: 0}).then(response => {
          this.getUnreadNotificationList()
        })
        if (type !== 'browserNotif') {
          if (type === 'Facility') {
            window.location.href = '#/visited-sites/' + uuid
          } else if (type === 'Complain') {
            window.location.href = '#/complaint/' + uuid
          } else if (type === 'Panic' || type === 'PanicResolve') {
            window.location.href = '#/panic-alerts/' + uuid
          } else if (type === 'Request') {
            window.location.href = '#/request/' + uuid
          } else if (type === 'Task') {
            window.location.href = '#/tasks/' + uuid
          } else {
            window.location.href = '#/visitor/' + uuid
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue